import styled from "styled-components";

export const HeaderWrapper = styled.div<{ $ismobile: string }>`
  height: 80px;
  display: flex;
  position: ${(props) => (props.$ismobile === "true" ? "fixed" : "static")};
  width: ${(props) => (props.$ismobile === "true" ? "100vw" : "")};
  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px,
    rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px,
    rgba(0, 0, 0, 0.07) 0px 16px 16px;
  z-index: 102;
  background: var(--secondary);
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    height: 80px;
    display: flex;
    justify-content: start;
    padding-left: 75px;

    img {
      width: 150px;
      height: 150px;
    }
  }
`;

export const HeaderImage = styled.img`
  margin-left: 0;
  margintop: -47px;
`;

export const HeaderButtonsWrapper = styled.div`
  align-items: center;
  justify-content: end;
  width: 100%;
  gap: 30px;
  margin-right: 5%;

  h4 {
    font-weight: 300;
    font-size: 1.25rem;
    font-family: "Roboto", sans-serif;
    color: var(--primary);
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  display: none;
  @media (min-width: 425px) {
    h2 {
      font-size: 1.5rem;
    }
  }
  @media (min-width: 768px) {
    display: flex;
  }
`;
